import { inject, Injectable } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { UserService } from '~/auth/services/user/user.service';
import { CheckoutService } from '~/checkout/services/checkout/checkout.service';
import { RedirectionService } from '~/core/services/redirection/redirection.service';

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  constructor(
    private readonly userService: UserService,
    private readonly redirectionService: RedirectionService,
    private readonly checkoutService: CheckoutService
  ) {}

  canActivate(): true | Promise<boolean> {
    const user = this.userService.getUser();

    if (!user) {
      return true;
    }

    if (this.checkoutService.isFreeCheckout() && !user.isProfileComplete()) {
      return this.redirectionService.redirect('/checkout.information', {
        queryParams: { to: 'summary' },
      });
    }

    return true;
  }
}

export const FreeCheckoutProfileCompleteGuard: CanActivateFn = ():
  | true
  | Promise<boolean> => {
  return inject(PermissionsService).canActivate();
};
